import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "sdk-forms-search",
  props: {
    inputPlaceholder: String,
    hasAppend: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    appendOptions: {
      type: Array as PropType<any[]>,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      search: "",
      selectedOption: "",
    };
  },
  methods: {
    sendSearch() {
      this.$emit("search", this.search, this.selectedOption);
    },
    sendModifier() {
      this.$emit("modifier-changed", this.selectedOption);
    },
  },
  mounted() {
    if (this.hasAppend) {
      this.selectedOption = this.appendOptions[0].value;
    }
  },
});
